import React, { useState, useEffect } from 'react';
import {
  useGetAllAssessmentMutation,
  usePostEditAssessmentMutation,
  usePostAssessmentMutation,
} from 'slices/get/assessment';
import useService from 'views/default/useService';
import { Badge, Col, Form, Row } from 'react-bootstrap';
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
  useRowSelect,
  useRowState,
} from 'react-table';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetAllCommonAdminInitialDataMutation } from 'slices/get/common';
import { format } from 'date-fns';
import { Modal, Button } from 'react-bootstrap';
import { FaImage, FaVideo } from 'react-icons/fa';


function useDayPlan() {
  const title = 'Day Plan';
  const description = 'Day Plan List';
  const [isOpenAddEditDeleteModal, setIsOpenAddEditDeleteModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [whichModal, setWhichModal] = useState('');
  const [editModalData, setEditModalData] = useState({});
  const location = useLocation();
  const currentPath = location.pathname;
  const history = useHistory()

  const [getAllAssessment] = useGetAllAssessmentMutation();
  const [postAssessment] = usePostAssessmentMutation();
  const [postEditAssessment] = usePostEditAssessmentMutation();
  const { checkAccessTime, fetchAccessToken } = useService();
  const [getAllCommonAdminInitialData] = useGetAllCommonAdminInitialDataMutation()
  const [data, setData] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const subjectId = queryParams.get('subjectId');
  const standardId = queryParams.get('standardId');
  const seriesId = queryParams.get('seriesId');
  const lessonId = queryParams.get('lessonId');
  const sectionId = queryParams.get('sectionId');
  const [modalData, setModalData] = useState({ show: false, type: '', data: [] });

useEffect(() => {
  const access_token = fetchAccessToken();

  getAllCommonAdminInitialData({ ep: `/school/day_plans?subjectId=${subjectId}&seriesId=${seriesId}&standardId=${standardId}&lessonId=${lessonId}&sectionId=${sectionId}`, token: access_token }).then((response) => {
    if (response && response?.data && response?.data?.data && response?.data?.data.length > 0) {
      // Creating a new object with the additional properties
      // const updatedData = response.data.data.map(item => ({
      //   ...item,  // copy existing properties
      //   titleAndImagesData: [
      //     {
      //       title: 'Nature Collection',
      //       image1: 'https://picsum.photos/id/1018/200/150',
      //       image2: 'https://picsum.photos/id/1025/200/150',
      //       image3: 'https://picsum.photos/id/1035/200/150',
      //     },
      //     {
      //       title: 'Urban Scenes',
      //       image1: 'https://picsum.photos/id/1043/200/150',
      //       image2: 'https://picsum.photos/id/1050/200/150',
      //       image3: 'https://picsum.photos/id/1062/200/150',
      //       image4: 'https://picsum.photos/id/1076/200/150',
      //       image5: 'https://picsum.photos/id/1084/200/150',
      //     },
      //   ],
      //   titleAndUrlsData: [
      //     {
      //       title: 'Tutorial Series',
      //       url1: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
      //       url2: 'https://www.youtube.com/watch?v=3JZ_D3ELwOQ',
      //       url3: 'https://www.youtube.com/watch?v=lTTajzrSkCw',
      //     },
      //     {
      //       title: 'Music Videos',
      //       url1: 'https://www.youtube.com/watch?v=Zi_XLOBDo_Y',
      //       url2: 'https://www.youtube.com/watch?v=kXYiU_JCYtU',
      //       url3: 'https://www.youtube.com/watch?v=2vjPBrBU-TM',
      //       url4: 'https://www.youtube.com/watch?v=09R8_2nJtjg',
      //       url5: 'https://www.youtube.com/watch?v=fLexgOxsZu0',
      //     },
      //   ],
      // }));

      checkAccessTime(response, currentPath);
      setData(response.data.data);
    }
  });
}, []);

  const columns = React.useMemo(() => {
    return [
      {
        Header: 'School',
        accessor: 'school_name',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-20',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      {
        Header: 'Standard',
        accessor: 'standard_name',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-20',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      {
        Header: 'Section',
        accessor: 'section_name',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-10',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      
      {
        Header: 'Lesson',
        accessor: 'lesson_name',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-20',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },

      {
        Header: 'Day',
        accessor: 'day',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-10',
        Cell: ({ cell }) => {
          return <div className="list-item-heading body">{cell.value}</div>;
        },
      },
      // {
      //   Header: 'Plan',
      //   accessor: 'plan',
      //   sortable: true,
      //   headerClassName: 'text-muted text-small text-uppercase w-40',
      //   Cell: ({ cell }) => {
      //     return <div className="list-item-heading body">{cell.value}</div>;
      //   },
      // },
    {
  Header: 'Images',
  accessor: 'Images',
  sortable: true,
  id: 'images',
  headerClassName: 'text-muted text-small text-uppercase w-5',
  Cell: ({ row }) => {
    const images = row.original.titleAndImagesData;
    return images && images.length > 0 ? (
      <FaImage
        role="button"
        className="text-primary"
        onClick={() =>
          setModalData({
            show: true,
            type: 'images',
            data: images,
          })
        }
      />
    ) : null;
  },
},
{
  Header: 'Videos',
  accessor: 'Images', // You might want to correct this accessor if it's not actually 'Images'
  sortable: true,
  id: 'videos',
  headerClassName: 'text-muted text-small text-uppercase w-5',
  Cell: ({ row }) => {
    const videos = row.original.titleAndUrlsData;
    return videos && videos.length > 0 ? (
      <FaVideo
        role="button"
        className="text-danger"
        onClick={() =>
          setModalData({
            show: true,
            type: 'videos',
            data: videos,
          })
        }
      />
    ) : null;
  },
},

      {
        Header: 'Status',
        accessor: 'active',
        sortable: true,
        headerClassName: 'text-muted text-small text-uppercase w-10',
        Cell: ({ cell }) => {
          return (
            <Badge bg={`outline-${cell.value === 'on' ? 'primary' : 'danger'}`}>{cell.value}</Badge>
          );
        },
      },
      {
        Header: '',
        id: 'action',
        headerClassName: 'empty w-10',
        Cell: ({ row }) => {
          const { checked, onChange } = row.getToggleRowSelectedProps();
          return (
            <Form.Check
              className="form-check float-end mt-1"
              type="checkbox"
              checked={checked}
              onChange={onChange}
            />
          );
        },
      },
    ];
  }, []);
//  const openModal = () => setIsOpen(true);
//   const closeModal = () => setIsOpen(false);
const closeModal = () =>{
  setModalData({ show: false, type: '', data: [] })
}
  const onOpenAddModal = () => {
    setIsOpen(true);
    setWhichModal('add');
  };

  const onOpenEditModal = (val) => {
    setIsOpen(true);
    setWhichModal('edit');
    setEditModalData(val);
  };

  const onOpenViewModal = (val) => {
    // console.log('tableInstance..........',tableInstance.selectedFlatRows[0].original.id)
    // let id = tableInstance.selectedFlatRows[0].original.id
    // history.push({
    //   pathname: `/assessment/quesions/${id}`,
    //   state: { 
    //     id, // Passing the id to the next component
    //     value: tableInstance.selectedFlatRows[0].original // You can pass more data like val here if needed
    //   }
    // });
    // let location = useLocation()
    // location.push('./assessmentQuetion')
    setIsOpen(true);
    setWhichModal('view');
    setEditModalData(val);
  };

  const onCloseEmptyModal = () => {
    setIsOpen(false);
    setWhichModal('');
    setEditModalData({});
  };

  const onCloseAddModal = async (values) => {
    onCloseEmptyModal();

    // setIsLoading(true);

    const access_token = fetchAccessToken();

    postAssessment({ ep: '/assessment/submit-form', values, token: access_token }).then(
      (response) => {
        

        checkAccessTime(response, currentPath);
        setData(response.data.data);
      }
    );
  };

  const onCloseEditModal = async (values) => {
    onCloseEmptyModal();

    // setIsLoading(true);

    const access_token = fetchAccessToken();

    postEditAssessment({ ep: '/assessment/submit-edit-form', values, token: access_token }).then(
      (response) => {
        // console.log(response);
        // console.log('Custom data from after_request:', response, response?.error);
        checkAccessTime(response, currentPath);
        setData(response.data.data);
      }
    );
  };

  const onCloseDeleteModal = async (values) => {

    // setIsLoading(true);
    let deletedIds = values.map(each=>each.id)
    const access_token = fetchAccessToken();

    postEditAssessment({
      ep: '/school/day_plans_delete',
      values: { dayPlanIds: deletedIds },
      token: access_token,
    }).then((response) => {
      // onCloseAddModal();
      window.location.reload();
      checkAccessTime(response, currentPath);
      // setData(response.data.data);
      onCloseEmptyModal();
    });
  };

  const tableInstance = useTable(
    {
      columns,
      data,
      isOpenAddEditDeleteModal,
      setIsOpenAddEditDeleteModal,
      isOpen,
      setIsOpen,
      whichModal,
      setWhichModal,
      editModalData,
      setEditModalData,
      editModalData,
      setEditModalData,
      onOpenAddModal,
      onOpenEditModal,
      onOpenViewModal,
      onCloseEmptyModal,
      onCloseAddModal,
      onCloseEditModal,
      onCloseDeleteModal,
      modalData,
      setModalData,
      // openModal,
      closeModal,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    useRowState,
      );

  return { title, description, data, tableInstance };
}

export default useDayPlan;
